<div class="wrapper default-button-theme">
  <div class="container" [class.vertical]="vertical">
    <div class="label">
      <ng-container *ngTemplateOutlet="label">
      </ng-container>
    </div>

    <mat-button-toggle-group multiple [vertical]="vertical" [value]="[value]" (change)="selectionChanged($event)"
                            (valueChange)="valueChanged($event)" #buttonGroup>
      <mat-button-toggle *ngFor="let item of items; index as i; trackBy: trackBy!" [value]="item" [disableRipple]="true">
        <ng-container *ngTemplateOutlet="content || defaultContent; context: makeContentContext(item, i)">
        </ng-container>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <!-- Default button content -->
    <ng-template #defaultContent let-item>
      {{ item }}
    </ng-template>
  </div>
</div>
